<div class="container">
    <div class="row">
        <div class="col-sm-12">
            <h4>Gewinner</h4>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-6">
            <form class="example-form">
                <mat-form-field class="full-width" appearance="fill">
                    <mat-label>Anzahl der Gewinner</mat-label>
                    <input matInput [formControl]="this.filterForm.controls.winnerCount">
                    <mat-hint>Die Liste der Gewinner ändert sich bei jeder Ziehung!</mat-hint>
                </mat-form-field>
            </form>
        </div>
    </div>

    <div class="row marginTop2Rem">
        <div class="col-sm-3">
            <button mat-button mat-raised-button color="accent" (click)="getWinners()">
                Anwenden
            </button>
        </div>
    </div>

    <table mat-table [dataSource]="dataSource"  class="mat-elevation-z2" *ngIf="hasSelectedWinnerCount"
        style="margin-top: 25px;">
        <ng-container matColumnDef="number">
            <th mat-header-cell *matHeaderCellDef>
                #
            </th>
            <td mat-cell *matCellDef="let element; let i = index;" class="mat-column">
                {{i+1}}
            </td>
        </ng-container>


        
        <ng-container matColumnDef="customerNumber">
            <th mat-header-cell  *matHeaderCellDef>
                Kundenummer
            </th>
            <td mat-cell *matCellDef="let element" class="mat-column">
                {{element.customerNumber}}
            </td>
        </ng-container>


        <ng-container matColumnDef="attendingAccount.displayName" class="mat-column">
            <th mat-header-cell  *matHeaderCellDef>
                Teilnehmer
            </th>
            <td mat-cell *matCellDef="let element">
                <span class="customLink" [routerLink]="['../../caseworker/dashboard/edit', element.customerPublicId]">
                    {{element.firstName}}     {{element.lastName}} 
                </span>
            </td>
        </ng-container>

        <ng-container matColumnDef="mail" class="mat-column">
            <th mat-header-cell  *matHeaderCellDef>
                E-Mail
            </th>
            <td mat-cell *matCellDef="let element">
                <span class="customLink" >
                    {{element.mail}}    
                </span>
            </td>
        </ng-container>


        <ng-container matColumnDef="voucherKey">
            <th mat-header-cell  *matHeaderCellDef>
                Code
            </th>
            <td mat-cell *matCellDef="let element" class="mat-column">
                {{element.voucherKey}}
            </td>
        </ng-container>

        <ng-container matColumnDef="paymentState" class="mat-column ">
            <th mat-header-cell *matHeaderCellDef>
                Zahlungsstatus
            </th>
            <td mat-cell *matCellDef="let element">
                <mat-chip-set>
                    <mat-chip class="accentChip" selected *ngIf="element.paymentState == 'null' ">
                        {{element.paymentState | translateState}}
                    </mat-chip>
                    <mat-chip class="primaryChip" selected *ngIf="element.paymentState != 'RESERVED' ">
                        {{element.paymentState | translateState}}
                    </mat-chip>
                </mat-chip-set>
            </td>
        </ng-container>

        
        <ng-container matColumnDef="event.title">
            <th mat-header-cell  *matHeaderCellDef>
                Aktion
            </th>
            <td mat-cell *matCellDef="let element" class="mat-column">
                <span class="customLink"
                    [routerLink]="['../../caseworker/event/edit/'+element.eventPublicId+'/advanced']">
                    {{element.eventTitle}}</span>
            </td>
        </ng-container>

        
        <ng-container matColumnDef="created" class="mat-column">
            <th mat-header-cell  *matHeaderCellDef matSortDirection="desc" matSortDisableClear>
                Reservierungsdatum
            </th>
            <td mat-cell *matCellDef="let element">
                {{element.reservationDate}}
            </td>
        </ng-container>
        <ng-container matColumnDef="state" class="mat-column ">
            <th mat-header-cell *matHeaderCellDef>
                Status
            </th>
            <td mat-cell *matCellDef="let element">
                <mat-chip-set>
                    <mat-chip class="primaryChip" selected *ngIf="element.state == 'RESERVED' ">
                        {{element.state | translateState}}
                    </mat-chip>
                    <mat-chip class="accentChip" selected *ngIf="element.state != 'RESERVED' ">
                        {{element.state | translateState}}
                    </mat-chip>
                </mat-chip-set>
            </td>
        </ng-container>
<!-- 
        <ng-container matColumnDef="paymentstate" class="mat-column ">
            <th mat-header-cell *matHeaderCellDef>
                Zahlungsstatus
            </th>
            <td mat-cell *matCellDef="let element">
                <mat-chip-set>
                    <mat-chip class="primaryChip" selected *ngIf="element.paymentState == 'PAID' ">
                        {{element.paymentState | translateState}}
                    </mat-chip>
                    <mat-chip class="accentChip" selected *ngIf="element.paymentState != 'PAID' ">
                        {{element.paymentState | translateState}}
                    </mat-chip>
                </mat-chip-set>
            </td>
        </ng-container> -->

        <!-- <ng-container matColumnDef="menu">
            <th mat-header-cell *matHeaderCellDef>
                Menü
            </th>
            <td mat-cell *matCellDef="let element">
                <button mat-icon-button style="margin: 0 auto !important;" [matMenuTriggerFor]="menu" color="accent">
                    <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                    <button mat-menu-item
                        [routerLink]="['../../../../caseworker/reservation']" [queryParams]="{filterByStates : 'RESERVED,USED', searchTerm: element.voucherKey}" >
                        <span>Zum Gutschein</span>
                    </button>
                    <button mat-menu-item
                        [routerLink]="['../../../../caseworker/dashboard/edit', element.customerPublicId]">
                        <span>Zum Kunden</span>
                    </button>
                    <button mat-menu-item
                        [routerLink]="['../../../../caseworker/event/edit/'+element.eventPublicId+'/advanced']">
                        <span>Zur Aktion</span>
                    </button>
                    <button mat-menu-item
                        [routerLink]="['../../../../caseworker/businessentity/edit', element.partnerPublicId]">
                        <span>Zum Partner</span>
                    </button>
                </mat-menu>
            </td>
        </ng-container> -->

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;let i = index">
        </tr>
    </table>


    <div class="row marginTop2Rem" *ngIf="hasSelectedWinnerCount">
        <div class="col-sm-12">
            <mat-form-field class="full-width">
                <mat-label>Gewinner:</mat-label>
                <textarea [(ngModel)]="this.currentWinnersCSV" matInput rows="10" cols="50"></textarea>
                <mat-hint>Code,Gewinner,Reservierungszeitpunkt,Status,Zahlungsstatus</mat-hint>
            </mat-form-field>
        </div>
    </div>

    <div class="row marginTop2Rem" *ngIf="hasSelectedWinnerCount">
        <div class="col-sm-3">
            <button mat-button mat-raised-button color="primary" (click)="exportCSV()">
                Daten als CSV exportieren
            </button>
        </div>
    </div>
    
</div>